import { memo } from 'react'

import CustomPopover, { type CustomPopoverProps } from '@components/CustomPopover'
import Button from '@components/formControls/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

const PopoverContent = styled(Box)`
  padding: 16px;
`

const Title = styled(Typography)`
  margin-bottom: 2px;
`

export const ActionsContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 15px;
`

export interface ConfirmPopoverProps extends CustomPopoverProps {
  title: string
  confirmBtnText: string
  onConfirm: () => void
  confirmDisabled?: boolean
  cancelBtnText: string
  onCancel: () => void
  height?: string
}

const ConfirmPopover = ({
  title,
  confirmBtnText,
  onConfirm,
  confirmDisabled = false,
  cancelBtnText,
  onCancel,
  children,
  height = 'auto',
  ...rest
}: ConfirmPopoverProps) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <CustomPopover {...rest}>
      <PopoverContent height={height}>
        <Title variant="h2">{title}</Title>
        <Box>{children}</Box>
        <ActionsContainer>
          <Button variant="outlined" onClick={onCancel}>
            {confirmBtnText}
          </Button>
          <Button variant="contained" onClick={onConfirm} disabled={confirmDisabled}>
            {cancelBtnText}
          </Button>
        </ActionsContainer>
      </PopoverContent>
    </CustomPopover>
  )
}

export default memo(ConfirmPopover)
